import React from "react";
import { useOutletContext } from "react-router-dom";
import * as supplierService from "../../services/supplierService";
import Invitations from "./Invitations";
import { DataTable, ProcBadge } from "../Proc/procUi";
import { EmptyState, LoadState, PageHeader, formatDate, pageStyle, useLoad } from "../../components/ui";

// Every buyer this supplier works for, in one place (one login, many buyers).
export default function SupplierBuyers() {
  const { me } = useOutletContext() || {};
  const { data, loading, error, reload } = useLoad(() => supplierService.getBuyers(), []);
  return (
    <div style={pageStyle}>
      <PageHeader title="Buyers" subtitle="The companies that have invited you to quote" />
      <Invitations canAccept={!!(me && me.is_primary_user)} onAccepted={reload} />
      <LoadState loading={loading} error={error} onRetry={reload}>
        <DataTable
          rows={data || []}
          minWidth={560}
          empty={<EmptyState title="No buyers yet" text="Buyers appear here once you accept their invitation." />}
          columns={[
            { label: "Buyer", render: (r) => <strong>{r.buyer_name}</strong> },
            { label: "Status", render: (r) => <ProcBadge status={r.status} label={r.status === "SUSPENDED" ? "On hold" : "Active"} /> },
            { label: "Since", render: (r) => formatDate(r.since) },
            {
              label: "Documents they asked for",
              render: (r) => (r.documents_required ? `${r.documents_given} of ${r.documents_required} uploaded · ${r.documents_approved} approved` : "None required"),
            },
          ]}
        />
      </LoadState>
    </div>
  );
}
